import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function FilledPlus({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99984 18.8332C14.6022 18.8332 18.3332 15.1022 18.3332 10.4998C18.3332 5.89746 14.6022 2.1665 9.99984 2.1665C5.39746 2.1665 1.6665 5.89746 1.6665 10.4998C1.6665 15.1022 5.39746 18.8332 9.99984 18.8332ZM10.6248 7.99984C10.6248 7.65466 10.345 7.37484 9.99984 7.37484C9.65466 7.37484 9.37484 7.65466 9.37484 7.99984L9.37484 9.87486H7.49984C7.15466 9.87486 6.87484 10.1547 6.87484 10.4999C6.87484 10.845 7.15466 11.1249 7.49984 11.1249H9.37484V12.9998C9.37484 13.345 9.65466 13.6248 9.99984 13.6248C10.345 13.6248 10.6248 13.345 10.6248 12.9998L10.6248 11.1249H12.4998C12.845 11.1249 13.1248 10.845 13.1248 10.4999C13.1248 10.1547 12.845 9.87486 12.4998 9.87486H10.6248V7.99984Z"
        fill="#71717A"
      />
    </svg>
  )
}
